import '@babel/polyfill'
import Vue from 'vue'
import './plugins'
import App from './App.vue'
import router from './router/index'
import './services'
import '@/assets/global.styl'
import 'element-ui/lib/theme-chalk/index.css'
import { Tabs, TabPane } from 'element-ui'
// import '@/assets/js/bmap.js'
// import '@/utils/amfe-flexible.js'
import store from './store'
import VueLazyComponent from '@xunlei/vue-lazy-component'
import CCMap from '@ccos/ccmap'

import focusable from 'vue-tv-focusable'

import * as dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import 'dayjs/locale/zh-cn' // import locale
import 'echarts-wordcloud'
import 'echarts/extension/bmap/bmap.js'
import VueCompositionApi from '@vue/composition-api'
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
require('echarts/lib/chart/bar')
require('echarts/lib/component/grid')

dayjs.extend(isLeapYear) // use plugin
dayjs.locale('zh-cn')
Vue.prototype.$dayjs = dayjs
Vue.use(focusable)
const vm = new Vue()
vm.$tv.init({
  // initDis: 30,
  focusClassName: 'btnFocus',
  findFocusType: 0,
  KEYS: {
    KEY_LEFT: [37], // ←
    KEY_UP: [38], // ↑
    KEY_RIGHT: [39], // →
    KEY_DOWN: [40], // ↓
    KEY_ENTER: [83, 13] // 83: s键  13：enter键
  }
})
window.CCMap = CCMap

// Vue.use(EVueEchartsjs)
Vue.use(VueLazyComponent)
Vue.use(VueCompositionApi)
Vue.config.productionTip = false
const checkUseragent = function () {
  var browser = {
    versions: (function () {
      var u = navigator.userAgent; var app = navigator.appVersion
      return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('android') > -1, // android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
      }
    }()),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
  if (browser.versions.ios) {
    return true
  } else if (browser.versions.android) {
    return true
  }
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return false
  } else {
    return false
  }
}
const setDevice = function () {
  return new Promise((resolve, reject) => {
    const isAndroid = checkUseragent()
    store.dispatch('toggleIisAndroid', isAndroid).then(() => {
      resolve()
    })
  })
}

Vue.prototype.$keyBoard = function () {
  document.onkeydown = function (event) {
    const e1 = event || window.event
    return e1.keyCode
    // let key = window.event.keyCode
    // if (key === code) {
    //   vm[methodName](code) // 触发methodName事件
    // }
  }
}

setDevice().then(() => {
  window.CVue = new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
})
